var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('menu-tree',{attrs:{"tree-data":_vm.navList,"default-active":_vm.defaultActive}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }